<script>
    import TextInput from './TextInput.svelte'

    export let value = '';
</script>

<div class='contextual-input'>
    <TextInput
        {...$$props}
        on:change
        bind:value
        on:focus
    />
</div>